import { DocumentConstructor } from "@/types";
import { IDataProvider } from "@/store";

export interface IDocumentConstructorState {
  documentConstructor: DocumentConstructor | null;
  documentConstructors: DocumentConstructor[] | null;
  dataProvider: IDataProvider<DocumentConstructor>;
}

export const state: IDocumentConstructorState = {
  documentConstructor: null,
  documentConstructors: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
